/**
 * FIFO queue with unique entries. Oldest entries are on the front. Pushing existing entries results in them being moved to the end.
 * @param listedIds
 * @param id
 * @param queueLength
 */
export function updateQueue(listedIds: string[], id: string, queueLength: number) {
  const filteredList = listedIds.filter((listedId) => listedId !== id);

  if (listedIds.length >= queueLength) {
    return [...filteredList.slice(-queueLength + 1), id];
  }

  return [...filteredList, id];
}
